<app-view-header></app-view-header>
<app-companion></app-companion>
<!--<ul>
  @if (screenService.isMobile) {
    <li class="mobile-sidenav-toggle">
      <fa-icon [icon]="fontawesomeService.light.bars" size="lg" (click)="toggleSidenav()"></fa-icon>
    </li>
    <li [routerLink]="['/dashboard']" class="mobile-logo">
      @if (themingService.theme === 'light') {
        <img src="./assets/img/logos/titled/blue_titled_dark.png" />
      }
      @if (themingService.theme === 'dark') {
        <img src="./assets/img/logos/titled/blue_titled_white.png" />
      }
    </li>
  }
  @if ((userAccount$ | async)?.adminLogin) {
    <li>
      <ct-lib-tag class="red">
        <fa-icon [icon]="fontawesomeService.light.exclamationTriangle" size="lg" disabled="true"></fa-icon>
        <p>{{ 'company-tool.topnav.logged-in-as-admin' | transloco }}</p>
      </ct-lib-tag>
    </li>
  }
  @if (!screenService.isMobile) {
    <li class="search">
      <app-search-input [(showSearch)]="showSearch" #searchInput></app-search-input>
      @if (!showSearch) {
        <fa-icon
          [tooltip]="'company-tool.topnav.search.title' | transloco"
          position="left"
          [icon]="fontawesomeService.light.search"
          size="lg"
          (click)="searchInput.toggle()"
        ></fa-icon>
      }
    </li>
    <li class="todos">
      <ng-container *ngTemplateOutlet="todosTemplate"></ng-container>
    </li>
    <li class="notifications">
      <ng-container *ngTemplateOutlet="notificationsTemplate"></ng-container>
    </li>
    @if ((exportsCount$ | async) > 0) {
      <li class="downloads">
        <ng-container *ngTemplateOutlet="downloadsTemplate"></ng-container>
      </li>
    }
  }
  @if (hasAdminPermission$ | async) {
    <li>
      <ct-lib-dropdown
        [dropdown]="creditsDropdownContent"
        [autowidth]="true"
        [alignment]="'right'"
        (clickOutside)="creditsDropdown.close()"
        #creditsDropdown
        >
        <app-credits-counter [size]="'md'"></app-credits-counter>
      </ct-lib-dropdown>
      <ng-template #creditsDropdownContent>
        <app-credits-counter-expanded></app-credits-counter-expanded>
      </ng-template>
    </li>
  }
  <li class="user">
    <div class="toggle" (mousedown)="showUserDropdown = true" tourAnchor="topnav-user">
      <div class="avatar">
        @if (avatarUrl$ | async; as avatar) {
          <img [src]="avatar" alt="avatar" />
        } @else {
          <app-avatar-placeholder
            [initials]="getUserInitials(userAccount$ | async)"
          ></app-avatar-placeholder>
        }
      </div>
        <p>{{ (userAccount$ | async)?.firstName }} {{ (userAccount$ | async)?.lastName }}</p>
        <app-rotating-chevron
          [toggle]="showUserDropdown"
          [baseState]="ChevronState.DOWN"
          [toggledState]="ChevronState.UP"
          class="ms-1"
        >
        </app-rotating-chevron>
        @if (screenService.isMobile && ((todosOpenOverall$ | async) || (notificationsUnseen$ | async))) {
          <div class="indicator"></div>
        }
      </div>
    @if (showUserDropdown) {
      <div
        class="dropdown"
        [class.darkmode]="themingService.theme === 'dark'"
        (clickOutside)="showUserDropdown = false"
        @fadeInOut
      >
    @if (screenService.isMobile) {
      <ul class="actions">
        <li>
          <fa-icon [icon]="fontawesomeService.light.search" size="lg" (click)="searchInput.toggle()"></fa-icon>
        </li>
        <li [routerLink]="['/dashboard']" class="mobile-logo">
          @if (themingService.theme === 'light') {
            <img src="./assets/img/logos/titled/blue_titled_dark.png" />
          }
          @if (themingService.theme === 'dark') {
            <img src="./assets/img/logos/titled/blue_titled_white.png" />
          }
        </li>
        <li class="mobile-sidenav-toggle">
          <fa-icon [icon]="fontawesomeService.light.times" size="lg" (click)="showUserDropdown = false"></fa-icon>
        </li>
      </ul>
    }
      <div class="content">
        <div class="top">
          <div class="search" [class.collapsed]="!searchInput.showSearch">
            <app-search-input [(showSearch)]="showSearch" #searchInput></app-search-input>
          </div>
          @if (screenService.isMobile) {
            <div class="avatar">
              @if (avatarUrl$ | async; as avatar) {
                <img [src]="avatar" alt="avatar" />
              } @else {
                <app-avatar-placeholder
                  [initials]="getUserInitials(userAccount$ | async)"
                ></app-avatar-placeholder>
              }
              <b>{{ (userAccount$ | async)?.firstName }} {{ (userAccount$ | async)?.lastName }}</b>
              <ul class="actions">
                <li class="todos">
                  <ng-container *ngTemplateOutlet="todosTemplate"></ng-container>
                </li>
                <li class="notifications">
                  <ng-container *ngTemplateOutlet="notificationsTemplate"></ng-container>
                </li>
                @if ((exportsCount$ | async) > 0) {
                  <li class="downloads">
                    <ng-container *ngTemplateOutlet="downloadsTemplate"></ng-container>
                  </li>
                }
              </ul>
            </div>
          }
        </div>
        <ul>
          <li [routerLink]="['/settings', 'profile']" routerLinkActive="active">
            <fa-icon [icon]="fontawesomeService.light.userCog" size="lg"></fa-icon>
            <p>{{ 'company-tool.topnav.profile' | transloco }}</p>
          </li>
          @if (hasAdminPermission$ | async) {
            <li [routerLink]="['/settings', 'company']" routerLinkActive="active">
              <fa-icon [icon]="fontawesomeService.light.cogs" size="lg"></fa-icon>
              <p>{{ 'company-tool.topnav.company' | transloco }}</p>
            </li>
          } @else {
            <li class="disabled" position="left" [tooltip]="'company-tool.sidenav.admin-only' | transloco">
              <fa-icon [icon]="fontawesomeService.light.cogs" size="lg"></fa-icon>
              <p>{{ 'company-tool.topnav.company' | transloco }}</p>
            </li>
          }
          <hr />
          <li (click)="releaseNotesModal.modal.open()">
            <fa-icon [icon]="fontawesomeService.light.commentAltEdit" size="lg"></fa-icon>
            <p>{{ 'company-tool.topnav.release-notes' | transloco }}</p>
          </li>
          <li>
            <fa-icon [icon]="fontawesomeService.light.globe" size="lg"></fa-icon>
            <ng-select
              [placeholder]="'company-tool.topnav.language' | transloco"
              [items]="languages"
              [bindLabel]="'name'"
              (change)="setLanguage($event.value)"
              [searchable]="false"
              [clearable]="false"
            >
            </ng-select>
          </li>
          <li (click)="themingService.toggleTheme()">
            @if (themingService.mode === 'auto') {
              <fa-icon [icon]="fontawesomeService.light.magic" size="lg"></fa-icon>
            }
            @if (themingService.mode === 'light') {
              <fa-icon [icon]="fontawesomeService.light.sun" size="lg"></fa-icon>
            }
            @if (themingService.mode === 'dark') {
              <fa-icon [icon]="fontawesomeService.light.moonStars" size="lg"></fa-icon>
            }
            <p>{{ 'company-tool.topnav.appearance' | transloco }}</p>
          </li>
          <hr />
          <li>
            <a href="https://knowledge.catch.hr/" target="_blank">
              <fa-icon [icon]="fontawesomeService.light.book" size="lg"></fa-icon>
              <p>
                {{ 'company-tool.topnav.knowledge-base' | transloco }}
                <fa-icon [icon]="fontawesomeService.light.externalLink"></fa-icon>
              </p>
            </a>
          </li>
          <hr />
          <li (click)="logout()">
            <fa-icon [icon]="fontawesomeService.light.signOutAlt" size="lg"></fa-icon>
            <p>{{ 'company-tool.topnav.logout' | transloco }}</p>
          </li>
        </ul>
      </div>
    </div>
    }
  </li>
</ul>
<app-release-notes-modal #releaseNotesModal></app-release-notes-modal>
<app-companion #companion></app-companion>
<ng-template #todosTemplate>
  <div class="icon" (mousedown)="showTodos = true">
    <fa-icon
      [tooltip]="'company-tool.topnav.todos.title' | transloco"
      position="left"
      [icon]="fontawesomeService.light.clipboardList"
      size="lg"
    ></fa-icon>
    @if ((todosOpenOverall$ | async) > 0) {
      <div class="indicator">
        <p>{{ todosOpenOverall$ | async }}</p>
      </div>
    }
  </div>
  @if (showTodos) {
  <div
    class="dropdown"
    [class.darkmode]="themingService.theme === 'dark'"
    (clickOutside)="showTodos = false"
    @fadeInOut
  >
    <div class="header">
      <h5>{{ 'company-tool.topnav.todos.title' | transloco }}</h5>
      <div class="actions">
        <div
          class="action"
          [tooltip]="'company-tool.topnav.todos.done-all-tooltip' | transloco"
          position="left"
          (click)="markAllAsDoneConfirmModal.modal.open()"
        >
          <fa-icon [icon]="fontawesomeService.light.check"></fa-icon>
        </div>
        <ct-lib-confirm-modal #markAllAsDoneConfirmModal (onConfirm)="markAllTodosAsDone()">
          <p>{{ 'company-tool.topnav.todos.mark-all-as-done-info' | transloco }}</p>
        </ct-lib-confirm-modal>
        <div
          class="action"
          [tooltip]="'company-tool.topnav.todos.delete-all-tooltip' | transloco"
          position="left"
          (click)="deleteAllConfirmModal.modal.open()"
        >
          <fa-icon [icon]="fontawesomeService.light.trash"></fa-icon>
        </div>
        <ct-lib-confirm-modal #deleteAllConfirmModal (onConfirm)="deleteAllTodos()">
          <p>{{ 'company-tool.topnav.todos.delete-all-info' | transloco }}</p>
        </ct-lib-confirm-modal>
        <div
          class="action"
          [tooltip]="'company-tool.topnav.close-tooltip' | transloco"
          position="left"
          (click)="showTodos = false"
        >
          <fa-icon [icon]="fontawesomeService.light.times"></fa-icon>
        </div>
      </div>
    </div>
    <div class="todos-wrapper" [class.no-todos]="(todos$ | async).length === 0">
      @if ((todos$ | async).length === 0) {
        <p class="text-center" @illustration>
          <img src="./assets/animations/line-arts/no-todos.svg" />
          {{ 'company-tool.topnav.todos.no-todos' | transloco }}
        </p>
      }
      @for (todo of todos$ | async; track todo.id) {
        <div
          class="todo"
          [routerLink]="getTodoRoute(todo)"
          (click)="showTodos = false"
        >
          <div class="header">
            <b>{{ getTodoApplicantName(todo) }}</b>
            <span>{{ todo.timestamp | date: 'short' }}</span>
          </div>
          <div class="body">
            <div class="content">
              @if (todo.hasProfilePicture && (getAvatarURL(todo.applicationId) | avatar | async); as image) {
                <img [src]="image" alt="" />
              } @else if (todo.hasProfilePicture) {
                <app-avatar-placeholder
                  [initials]="getInitials(todo.firstName, todo.lastName)"
                ></app-avatar-placeholder>
              } @else {
                <div class="icon-wrapper">
                  <fa-icon [icon]="fontawesomeService.light.clipboardList"></fa-icon>
                </div>
              }
              <span>{{ getTodoDescription(todo) }}</span>
            </div>
            <div class="actions" (click)="$event.stopPropagation()">
              <fa-icon
                class="delete"
                [icon]="fontawesomeService.light.times"
                [tooltip]="'company-tool.topnav.todos.delete-tooltip' | transloco"
                position="left"
                (click)="onDeleteTodoModal.modal.open()"
              ></fa-icon>
              <ct-lib-confirm-modal #onDeleteTodoModal (onConfirm)="deleteTodo(todo)">
                {{ 'company-tool.topnav.todos.delete-modal' | transloco }}
              </ct-lib-confirm-modal>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
  }
</ng-template>
<ng-template #notificationsTemplate>
  <div class="icon" (mousedown)="showNotifications = true">
    <fa-icon
      [tooltip]="'company-tool.topnav.notifications.title' | transloco"
      position="left"
      [icon]="fontawesomeService.light.bell"
      size="lg"
    ></fa-icon>
    @if ((notificationsUnseen$ | async) > 0) {
      <div class="indicator">
        <p>{{ notificationsUnseen$ | async }}</p>
      </div>
    }
  </div>
  @if (showNotifications) {
  <div
    class="dropdown"
    [class.darkmode]="themingService.theme === 'dark'"
    (clickOutside)="showNotifications = false"
    @fadeInOut
  >
    <div class="header">
      <h5>{{ 'company-tool.topnav.notifications.title' | transloco }}</h5>
      <div class="actions">
        <div
          class="action"
          [tooltip]="'company-tool.topnav.notifications.seen-all-tooltip' | transloco"
          position="left"
          (click)="markAllNotificationsAsSeen()"
        >
          <fa-icon [icon]="fontawesomeService.light.eye"></fa-icon>
        </div>
        <div
          class="action"
          [tooltip]="'company-tool.topnav.notifications.open-settings' | transloco"
          position="left"
          (click)="navigateToNotificationSettings(); showNotifications = false"
        >
          <fa-icon [icon]="fontawesomeService.light.filter"></fa-icon>
        </div>
        <div
          class="action"
          [tooltip]="'company-tool.topnav.close-tooltip' | transloco"
          position="left"
          (click)="showNotifications = false"
        >
          <fa-icon [icon]="fontawesomeService.light.times"></fa-icon>
        </div>
      </div>
    </div>
    <div
      class="notifications-wrapper"
      [class.no-notifications]="(notifications$ | async).length === 0 && !(notificationsLoading$ | async)"
      scrollEndRoot
    >
      <app-notifications (notificationNavigate)="showNotifications = false"></app-notifications>
      <div (scrollEnd)="loadMoreNotifications()" rootMargin="0px 0px 250px 0px"></div>
      @if (notificationsLoading$ | async) {
        <div class="loader d-flex justify-content-center mt-3">
          <ct-lib-spinner></ct-lib-spinner>
        </div>
      }
    </div>
  </div>
  }
</ng-template>

<ng-template #downloadsTemplate>
  <div class="icon" (mousedown)="openDownloadsDropdown()">
    <fa-icon
      [tooltip]="'company-tool.topnav.downloads.title' | transloco"
      position="left"
      [icon]="fontawesomeService.light.download"
      size="lg"
    ></fa-icon>
    @if ((exportsCount$ | async) > 0) {
      <div class="indicator">
        <p>{{ exportsCount$ | async }}</p>
      </div>
    }
  </div>
  @if ((showDownloads$ | async) && (exportsCount$ | async) > 0) {
    <div
      class="dropdown"
      [class.darkmode]="themingService.theme === 'dark'"
      (clickOutside)="closeDownloadsDropdown()"
      @fadeInOut
    >
    <div class="header">
      <h5>{{ 'company-tool.topnav.downloads.title' | transloco }}</h5>
      <div class="actions">
        <div
          class="action"
          [tooltip]="'company-tool.topnav.close-tooltip' | transloco"
          position="left"
          (click)="closeDownloadsDropdown()"
        >
          <fa-icon [icon]="fontawesomeService.light.times"></fa-icon>
        </div>
      </div>
    </div>
    <div class="downloads-wrapper" [class.no-downloads]="(allExports$ | async)?.length === 0">
      @if ((allExports$ | async)?.length === 0) {
        <p class="text-center" @illustration>
          {{ 'company-tool.topnav.downloads.no-downloads' | transloco }}
        </p>
      }
      @for (exportItem of (allExports$ | async) ?? []; track exportItem.exportId) {
        <div class="download-item">
          <div class="content">
            <b>{{ exportItem.jobTitle }}</b>
            <span>{{ exportItem.isPending ? ('company-tool.topnav.downloads.preparing' | transloco) : exportItem.filename }}</span>
            @if (!exportItem.isPending && exportItem.creationTime) {
              <span class="timestamp">{{ exportItem.creationTime | date: 'medium' }}</span>
            }
          </div>
          <div class="actions">
            @if (exportItem.isPending) {
              <div class="spinner-wrapper">
                <ct-lib-spinner></ct-lib-spinner>
              </div>
              <fa-icon
                class="remove"
                [icon]="fontawesomeService.light.times"
                [tooltip]="'company-tool.topnav.downloads.remove' | transloco"
                position="left"
                (click)="removeExport(exportItem)"
              ></fa-icon>
            } @else {
              <fa-icon
                [icon]="fontawesomeService.light.download"
                [tooltip]="'company-tool.topnav.downloads.download' | transloco"
                position="left"
                (click)="downloadExport(exportItem)"
              ></fa-icon>
              <fa-icon
                class="remove"
                [icon]="fontawesomeService.light.times"
                [tooltip]="'company-tool.topnav.downloads.remove' | transloco"
                position="left"
                (click)="removeExport(exportItem)"
              ></fa-icon>
            }
          </div>
        </div>
      }
    </div>
    </div>
  }
</ng-template>
<ng-template #searchTemplate></ng-template>
-->
